import React from 'react'
import { userStore, categoryStore } from './store'

const contextList = {
    userStore,
    categoryStore,
}

export const storeContext = React.createContext(contextList)

export const StoreProvider = ({ children }) => {
    return <storeContext.Provider value={contextList}>{children}</storeContext.Provider>
}

export default StoreProvider



// WEBPACK FOOTER //
// ./src/m_header/stores/context.js